import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import debounce from 'lodash.debounce'
import { authService, settingGeneralService } from '../../../services'
import { fetchProviders } from '../../../states/actions/provider'
import { ProviderMenu } from '../../../constants'
import { apiHostname } from '../../../config'
import { exportFile, queryString, validator } from '../../../util'

// UI
import { Button, ControlLabel, Page, Pager, SearchInput } from '../../../components'
import { Permissions } from '../../../constants'
import notify from '../../../components/Notification'

import './styles.css'

import Col from 'antd/lib/col'
import Row from 'antd/lib/row'
import Select from 'antd/lib/select'
import Skeleton from 'antd/lib/skeleton'

const pageSize = 40
const Option = Select.Option

export class Provider extends Component {
  constructor (props) {
    super(props)
    const { providers: { list, total }, loading } = props
    this.state = {
      currentPage: 1,
      filter: { active: true },
      list,
      loading,
      loadingSetting: false,
      searching: false,
      searchText: '',
      sort: {},
      total,
      languageList: [],
      serviceList: [],
      isGenerating: false
    }
    this.onSearchName = debounce(this.onSearchName, 500)
    this.onSelectActive = this.onSelectActive.bind(this)
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    const { providers: { list, total }, loading } = nextProps
    const state = { ...prevState, list, loading, total }
    if (list !== prevState.list) {
      state.searching = false
    }
    return state
  }

  componentDidMount () {
    this.fetchSettings()
    const { currentPage, filter, loading, searchText, sort } = this.state
    this.fetchProviders({ currentPage, filter, loading: true, searchText, sort })
  }

  onSearchName (value) {
    const { currentPage, filter, loading, sort } = this.state
    this.setState({ searching: true })

    if (value.indexOf(' ') >= 0) {
      const words = value.split(' ')
      if (Array.isArray(words)) {
        filter.$and = []

        for (let i = 0; i < words.length; i++) {
          filter.$and.push({
            $or: [
              { fullname: { condition: 'ilike', value: `%${words[i]}%` } },
              // { abn: { condition: 'ilike', value: `%${words[i]}%` } },
              // { acc_ref: { condition: 'ilike', value: `%${words[i]}%` } },
              // { suburb: { condition: 'ilike', value: `%${words[i]}%` } }
            ]
          })
        }
      }
    } else {
      if (Array.isArray(filter.$and)) {
        delete filter.$and
      }
    }
    this.fetchProviders({ currentPage: 1, filter, loading, searchText: (filter.$and ? '' : value), sort })
    this.setState({ searchText: value, currentPage: 1 })
  }

  onSelectActive (value) {
    const { currentPage, filter, loading, searchText, sort } = this.state
    filter.active = value
    this.fetchProviders({ currentPage, filter, loading, searchText, sort })
    this.setState({ filter })
  }

  hasAccess (accessLevel) {
    return authService.hasAccess(accessLevel)
  }

  renderProvider (item) {
    const { id, abn, acc_ref, fullname, email, phone_number, suburb, active } = item

    return (
      <div className={`list-item ${active ? '' : 'list-item-dim'}`}>
        <Row className='list-content'>
          <Col md={6}><img alt='' src={process.env.PUBLIC_URL + '/img/love.png'} className='avatar' /></Col>

          <Col md={18}>
            <div className='name'>{fullname}</div>
            <div style={{ fontSize: '8pt' }}>{email}</div>
            <div style={{ fontSize: '8pt' }}>{phone_number}</div>
          </Col>
        </Row>
      </div>
    )
  }

  render () {
    const { currentPage, isGenerating, languageList, list, loading, searching, serviceList, total } = this.state

    return (
      <Page.Body>
        <Page.Left>
          <Page.Menu title='Home' menu={ProviderMenu} />
        </Page.Left>
        <Page.Content full>
          <Page.Header title='Providers'>
            { this.hasAccess(Permissions.PROVIDER.INFO.LIST)
              ? <Button feedback={isGenerating} onClick={() => this.export()}>
                EXPORT
              </Button>
              : null }

            { this.hasAccess(Permissions.PROVIDER.INFO.CREATE)
              ? <Link to='/providers/add'>
                <div className='btn'>
                  Add
                </div>
              </Link>
              : null }

            {/* {
              this.hasAccess('listFunders') ? <div className='btn' onClick={() => this.export()}>
              Export
              </div> : null
            } */}
          </Page.Header>

          <Page.Filter>
            { this.hasAccess(Permissions.PROVIDER.INFO.LIST)
              ? <div>
                <Row gutter={8}>
                  <Col lg={8}>
                    <ControlLabel>Name, Acc Ref ID</ControlLabel>
                    <SearchInput placeholder='Search providers' onChange={(v) => this.onSearchName(v)} isSearching={searching} />
                  </Col>
                  <Col lg={8}>
                    <ControlLabel>Active</ControlLabel>
                    <Select defaultValue='true' style={{ width: 120 }} onChange={this.onSelectActive}>
                      <Option value='true'>Active</Option>
                      <Option value='false'>Inactive</Option>
                    </Select>
                  </Col>
                </Row>

                <Row gutter={8} style={{ marginBottom: 20, marginTop: 20 }}>
                  <Col lg={10}>
                    <ControlLabel>Languages</ControlLabel>
                    <Select
                      style={{width: '100%'}}
                      mode='multiple'
                      onChange={(value, option) => this.onChangeFilters(value, option, 'sc_languages')}
                      showSearch
                      filterOption={(input, option) => this.filterOptions(input, option)}>
                      { languageList.map((s, idx) => {
                          return <Option key={`lngls${s.id}`} value={s.id}>{s.name}</Option>
                        }) }
                    </Select>
                  </Col>
                  <Col lg={10}>
                    <ControlLabel>Services Provided</ControlLabel>
                    <Select
                      style={{width: '100%'}}
                      mode='multiple'
                      onChange={(value, option) => this.onChangeFilters(value, option, 'sc_provider_services')}
                      showSearch
                      filterOption={(input, option) => this.filterOptions(input, option)}>
                      { serviceList.map((s, idx) => {
                          return <Option key={`svcls${s.id}`} value={s.id}>{s.name}</Option>
                        }) }
                    </Select>
                  </Col>
                </Row>
              </div>
              : null }

          </Page.Filter>

          <div className='providers'>
            <Skeleton loading={loading} active>
              {list.map((item) => {
                const { id, ref_id } = item

                return (
                  this.hasAccess(Permissions.PROVIDER.INFO.READ)
                  ? <Link to={`/providers/${ref_id}/info`} key={id}>
                    { this.renderProvider(item) }
                    </Link>
                  : this.renderProvider(item)
                )
              })}
            </Skeleton>
          </div>

          <Pager
            size={pageSize}
            total={total}
            totalText={`Total ${total} Provider${total === 1 ? '' : 's'}`}
            current={currentPage}
            onChange={this.changePage}
            style={{ marginTop: '15px' }}
          />
        </Page.Content>
      </Page.Body>
    )
  }

  changePage = (currentPage) => {
    const { filter, searchText, sort } = this.state
    this.fetchProviders({ currentPage, filter, searchText, sort })
  }

  fetchProviders = async ({ loading = true, currentPage = 1, filter = {}, sort = {}, searchText }) => {
    if (!this.hasAccess(Permissions.PROVIDER.INFO.LIST)) return

    try {
      // const { fetchProviders } = this.props
      this.setState({ currentPage })

      this.props.fetchProviders({ loading, currentPage, pageSize, filter, sort, searchText })
    } catch (e) {
      notify.error('Unable to load successfully', 'Unable to load providers successfully. Please try again later.')
    }

    this.scrollToTop()
  }

  fetchSettings = async () => {
    this.setState({ loadingSetting: true })
    const filter = {}
    filter.identifier = {
      $or: [
        { condition: '=', value: 'sc-provider-services' },
        { condition: '=', value: 'language' },
      ]
    }
    filter.active = { condition: '=', value: true }

    const settings = await settingGeneralService.listByPage(1, 0, filter)

    if (settings && settings.list && validator.isArray(settings.list)) {
      this.setState({
        settings: settings.list,
        languageList: settings.list.filter(item => item.identifier === 'language'),
        serviceList: settings.list.filter(item => item.identifier === 'sc-provider-services'),
        loadingSetting: false
      })
    }
  }

  filterOptions = (input, option) => {
    const text = option.props.children

    return text.toLowerCase().indexOf(input.toLowerCase()) >= 0
  }

  onChangeFilters = (values, options, type) => {
    const { filter } = this.state

    if (validator.isNotEmptyArray(values)) {
      filter[type] = { condition: '@>', value: values }
    } else {
      delete filter[type]
    }

    this.setState({ filter }, () => this.changePage(1))
  }

  export = async() => {
    const { filter } = this.state

    this.setState({ isGenerating: true })
    const r = await exportFile.fetchExport('provider')
    setTimeout(() => {
      this.setState({ isGenerating: false })
    }, 2000)
  }

  scrollToTop = () => {
    if (window) {
      window.scrollTo(0, 0)
    }
  }
}

const mapDispatchToProps = {
  fetchProviders
}

const mapStateToProps = (state) => {
  return { ...state.Provider }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Provider)
